module.exports = __webpack_public_path__ + "static/img/wap.5677777.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/北京中加学校/wap.svg
// module id = YKeN
// module chunks = 16